import { Stack } from '@ethings/ui-toolkit';
import { ChangeEvent, type JSX } from 'react';
import { CommonEntity } from '../../../../types';
import { LayerSelectionCheckBox } from '../layer-selection-check-box';

interface Props<T> {
  disabled?: boolean;
  handleAllChange: () => void;
  handleIndividualChange: (e: ChangeEvent<HTMLInputElement>) => void;
  indeterminate: boolean;
  isAllChecked: boolean;
  isSubSectionItemChecked: (id: string) => boolean;
  subSectionItems: T[];
  subSectionLabel: string;
}

/**
  * NATIVE FUNCTION: Component for Layer Selection - Sub Menu Section
  */
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function SubMenuSection<T extends CommonEntity>({
  disabled,
  handleAllChange,
  handleIndividualChange,
  indeterminate,
  isAllChecked,
  isSubSectionItemChecked,
  subSectionItems,
  subSectionLabel,
}: Props<T>): JSX.Element {
  return (
    <Stack mt={1}>
      <LayerSelectionCheckBox
        checked={isAllChecked}
        disabled={disabled}
        handleClick={handleAllChange}
        indeterminate={indeterminate}
        label={subSectionLabel}
      />
      <Stack ml={3}>
        {subSectionItems?.map((item, i) =>
          <LayerSelectionCheckBox
            key={i}
            checked={isSubSectionItemChecked(item._id)}
            disabled={disabled}
            handleClick={handleIndividualChange}
            label={item.display}
            value={item._id}
          />,
        )}
      </Stack>
    </Stack>
  );
}
